import * as DeveloperActions from 'app/developer-v3/Actions';
import { hasUnsavedChanges } from 'app/developer-v3/selectors';
import { notify } from 'app/developer-v3/store/shared/actions';

import type { Dispatch } from 'app/common/types';

const isMenuClick = event => {
  const columns = event.currentTarget.children;
  const menuColumn = columns[columns.length - 1];

  return menuColumn.contains(event.target);
};

const warnIfLeavingUnsavedChanges = ({
  cancelRoute,
  getState,
  dispatch,
}: {
  cancelRoute: () => void;
  getState: () => any;
  dispatch: Dispatch;
}) => {
  const state = getState();
  if (hasUnsavedChanges(state)) {
    cancelRoute();
    const message = `It seems you have made changes that weren't saved yet. Please save them, or try going again where you were going.`;
    dispatch(notify.info(message));
    dispatch(DeveloperActions.setUnsavedChanges(false));
  }
};

export { isMenuClick, warnIfLeavingUnsavedChanges };
